import { VFC } from 'react';

const Maintenance: VFC = () => {

  return (
    <div className='mx-auto my-0 max-w-xl relative py-0 px-4 text-center w-full sm:max-w-5xl'>
      <div className='text-center max-w-md mx-auto'>
        <div className='flex justify-center mt-4'>
          <img
            src={'/img/logo_panda.png'}
            alt='logo_panda'
            width='200px'
            style={{ marginBottom: '80px' }}
          />
        </div>
        <h1 className='text-pandacco text-2xl mt-0 mx-auto mb-4'>
          ただいまメンテナンス中です</h1>
        <p>大変ご迷惑をおかけしておりますが、</p>
        <p>もうしばらくお待ちください。</p>
        <p>メンテナンスが終了次第、再度ご利用いただけます。</p>
      </div>
    </div>
  );
};

export default Maintenance;
